import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';
declare var google: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

    static componentName = 'FooterComponent';
    mapMode: Boolean = false; // False means the map is not in "full" mode
    map: any;

    constructor(
        private dataService: DataService,
    ) {}

    ngOnInit() {
        const mapProp = {
            center: new google.maps.LatLng(59.331188, 18.063188),
            zoom: 14,
            disableDefaultUI: true,
            draggable: false,
            zoomControl: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            styles: [{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"off"}]},
                {"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},
                {"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},
                {"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},
                {"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},
                {"featureType":"road","elementType":"all","stylers":[{"color":"#000000"}]},
                {"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},
                {"featureType":"road","elementType":"labels.text","stylers":[{"visibility":"off"}]},
                {"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"off"}]},
                {"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},
                {"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},
                {"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},
                {"featureType":"water","elementType":"all","stylers":[{"color":"#cfd5d8"},{"visibility":"on"}]}]
        };
        const map = new google.maps.Map(document.getElementById("footer-map"), mapProp);
        this.map = map;

        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(59.331188, 18.063188),
            map: map,
            icon: {url: '../../assets/img/pin.png'}
        });
    }

    toggleMap() {
        this.mapMode = !this.mapMode;

        const mapEl = document.querySelectorAll('div.footer-map');
        if (this.mapMode) {
            mapEl[0].classList.add('full');
            google.maps.event.trigger(this.map, 'resize');
            this.map.setCenter(new google.maps.LatLng(59.331188, 18.063188));
        } else {
            mapEl[0].classList.remove('full');
            google.maps.event.trigger(this.map, 'resize');
            this.map.setCenter(new google.maps.LatLng(59.331188, 18.063188));
        }
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/footer/footer.component.ts